import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import Edit from '../crud/edit'
import fields from './edit-fields'
import menuItems from './menuItems'
import { Dialog, FlatButton, RaisedButton } from 'material-ui'
import { setSnackbarMessage } from '../../actions/snackbar'
import api from '../../api'

const buttonStyle = {
  margin: '1em 1em 0 0'
}

class EditInstitutionMembership extends Component<any, any> {
  constructor (props) {
    super(props)
    this.state = {
      showRenew: false,
      lastUpdatedAt: new Date(),
      dialogTitle: 'Renew Confirmation',
      dialogMessage: 'Are you sure you want to renew this membership?',
      isErrorDialog: false
    }
  }

  handleRenew () {
    this.setState({
      showRenew: true
    })
  }

  handleRenewConfirm () {
    api
      .post(`admin/memberships/${this.props.params.membershipId}/renew`)
      .then(res => {
        res.json().then(data => {
          if (res.ok) {
            this.props.onSnackbarMessage(`Successfully renewed #${data.id}`)
            this.setState({
              showRenew: false,
              lastUpdatedAt: new Date()
            })
          } else {
            this.setState({
              dialogTitle: 'Error',
              dialogMessage: data.message,
              isErrorDialog: true
            })
          }
        })
      })
  }

  handleRenewCancel () {
    this.setState({
      showRenew: false
    })
  }

  handleError () {
    this.setState({
      showRenew: false,
      dialogTitle: 'Renew Confirmation',
      dialogMessage: 'Are you sure you want to renew this membership?',
      isErrorDialog: false
    })
  }

  render () {
    const renewActions = [
      <FlatButton
        label='Cancel'
        primary
        onClick={this.handleRenewCancel.bind(this)}
      />,
      <FlatButton
        label='Renew'
        primary
        keyboardFocused
        onClick={this.handleRenewConfirm.bind(this)}
      />
    ]

    const errorActions = [
      <FlatButton
        label='ok'
        primary
        onClick={this.handleError.bind(this)}
      />
    ]

    return (
      <div>
        <Edit
// @ts-ignore
          lastUpdatedAt={this.state.lastUpdatedAt}
          title='Edit Institution Membership'
          fields={fields}
          apiPath={`admin/memberships/${this.props.params.membershipId}`}
          successRedirectPath='/membership/institution-memberships'
          buildMenuItems={menuItems}
        />
        <RaisedButton label='Renew' onClick={this.handleRenew.bind(this)} primary style={buttonStyle} />

        <Dialog
          title={this.state.dialogTitle}
          actions={this.state.isErrorDialog ? errorActions : renewActions}
          modal={false}
          open={this.state.showRenew}
          onRequestClose={this.handleRenewCancel.bind(this)}
        >
          {this.state.dialogMessage}
        </Dialog>
      </div>
    )
  }
}

// @ts-ignore
EditInstitutionMembership.propTypes = {
  onSnackbarMessage: PropTypes.func.isRequired
}

const mapStateToProps = (state) => ({})

const mapDispatchToProps = (dispatch) => ({
  onSnackbarMessage: (msg) => {
    dispatch(setSnackbarMessage(msg))
  }
})

// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(EditInstitutionMembership)
